export const themeTypes = {
  SET_THEME: 'SET_THEME',
  RESET_THEME: 'RESET_THEME',
  GET_THEMES: 'GET_THEMES',
};

export type IThemeState = Readonly<ThemePayload>;

export type ThemePayload = {
  primary: string;
  secondary: string;
  backgroundUrl: string;
};
